﻿ 

class TabGroupItem {
    constructor(el, index) {
        this.render(el, index);
    }

    static get CLASSES() {
        return {
            active: "--active"
        }
    }

    tab__CLICK(e) {
        if (e.type === "click" || (e.type === "keypress" && event.which === 13)) {
            var tabClicked = $(e.currentTarget);
            var tabClickedIndex = tabClicked.data('tab-index');
             
            this.goToTab(tabClickedIndex);
        }
    }

    jumpToTab__CLICK(event) {
        var targetIndex = $(event.currentTarget).data('tab-index');
        this.goToTab(targetIndex);
    }

    

    goToTab(index) {

        if (index === this.currentSlideIndex) {
            return;
        }
        //console.log(this.currentTab);
        //console.log(this.currentContainer);

        if (this.currentTab) {
            this.currentTab.removeClass(TabGroupItem.CLASSES.active);
        }
        if (this.currentContainer) {
            this.currentContainer.removeClass(TabGroupItem.CLASSES.active);
        }

        var targetTabSelector = `[data-tab-index="${index}"]`;

        this.currentTab = this.tabSwitchers.filter(targetTabSelector)
        this.currentContainer = this.tabsContainers.filter(targetTabSelector);

        this.currentTab.addClass(TabGroupItem.CLASSES.active);
        this.currentContainer.addClass(TabGroupItem.CLASSES.active);

        this.currentSlideIndex = index;
        this.element.trigger('tab.changed');
    }



    tab__CHANGE(event) {
        var total = this.tabSwitchers.length;
        var index = this.tabSwitchers.index(this.currentTab);
        if (index >= 0) {
            var completed = 100 - (((index + 1) / total) * 100);
            this.tagProgress.css('--progress', `${completed * -1}%`);
        }
    }


    render(el, index) {
        this.element = $(el);
        this.currentSlideIndex = 0;
        var tabsFor = this.element.data('tabs-for');
        if (!tabsFor) {
            console.error('no tabs container for tabs');
        }
        this.tabsContainer = $('#' + tabsFor);
        this.tabsContainers = this.tabsContainer.find('[data-ref="tab-container"]');

        this.tagProgress = this.element.find('[data-component="tab-progress"]');

        this.tabSwitchers = this.element.find('[data-ref="tab-switcher"]');

        this.tagLink = this.tabsContainer.find('[data-ref="tab-link"]');

        this.tagLink.on('click', this.jumpToTab__CLICK.bind(this));

        this.tabSwitchers.on('click keypress', this.tab__CLICK.bind(this));
        this.element.on('tab.changed', this.tab__CHANGE.bind(this));

        this.init();
    }

    init() {
        var activeTab = this.tabSwitchers.filter(`.${TabGroupItem.CLASSES.active}`);
        var activeContainer = this.tabsContainers.filter(`.${TabGroupItem.CLASSES.active}`);

        this.currentContainer = activeContainer;
        this.currentTab = activeTab;
        this.element.trigger('tab.changed');

    }

}


class TabGroup {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }
 
    render(el, index) {
        new TabGroupItem(el, index);
    }
}

export default TabGroup;